// Shared display map + override vocabulary for the Drug–Diagnosis FDA Approval Check.
// One source so the card chips, the override dialog, and any future surface stay in sync.
// `processing` and `unverified` must read as in-flight / not-checked, NOT as claims about the drug.
export const VERDICT_DISPLAY = {
    on_label: { color: "success", label: "On-label", icon: "mdi-check-circle" },
    off_label: { color: "warning", label: "Off-label", icon: "mdi-information" },
    not_indicated: { color: "primary", label: "Not indicated", icon: "mdi-alert-circle" },
    processing: { color: "info", label: "Verifying…", icon: "mdi-progress-clock" },
    unverified: { color: "grey", label: "Not checked", icon: "mdi-help-circle" },
};
export const verdictDisplay = (verdict) => VERDICT_DISPLAY[verdict ?? ""] || VERDICT_DISPLAY.unverified;
// Verdicts a user may PROPOSE in an override request (mirrors backend OVERRIDABLE_VERDICTS).
export const REQUESTABLE_VERDICT_OPTIONS = ["on_label", "off_label", "not_indicated"].map((value) => ({
    value,
    label: VERDICT_DISPLAY[value].label,
}));
// Verdicts whose row may be DISPUTED (a request opened from it) — includes `unverified`,
// where a human supplies the verdict the system could not.
export const DISPUTABLE_VERDICTS = new Set(["on_label", "off_label", "not_indicated", "unverified"]);
export const OVERRIDE_STATUS = {
    PENDING: "pending",
    APPROVED: "approved",
    DENIED: "denied",
};
